import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Container, Logo, Text } from './styles';
import logo from '../../assets/cp-logo.png';

function normalizeDeepLink(url: string) {
  if (!url.includes('?') && url.includes('&')) {
    return url.replace('&', '?');
  }
  return url;
}

export default function CorosAuth() {
  const [searchParams] = useSearchParams();

  const rawRedirectUrl = searchParams?.get('redirect_url');
  const redirectUrl = rawRedirectUrl ? normalizeDeepLink(rawRedirectUrl) : null;

  useEffect(() => {
    if (!redirectUrl) return undefined;

    const timer = setTimeout(() => {
      window.location.replace(redirectUrl);
    }, 300);

    return () => clearTimeout(timer);
  }, [redirectUrl]);

  return (
    <Container>
      <Logo src={logo} alt="logo" />

      <Text>{`Redirecionando para ${redirectUrl ?? 'o Corrida Perfeita'}`}</Text>
    </Container>
  );
}
